import { Component, OnInit, Input } from '@angular/core';
import { FormField } from '../../../common/models/form-details.model';
import { FormControl, FormGroup } from '@angular/forms';
import { Ws10FormElementBlock } from '@vfde-fe/ngx-lib/brix/ws10-form-element-block';
import { IFormSelectItem } from '@vfde-fe/ngx-lib/brix/ws10-form-select';
import { TranslateService } from '@ngx-translate/core';
import { SELECTED } from 'src/app/common/constants/Defines';

/** SelectBlockComponent */
@Component({
  selector: 'app-select-block',
  templateUrl: './select-block.component.html',
})
export class SelectBlockComponent implements OnInit {
  /** formField */
  @Input() public formField: FormField;

  /** form */
  @Input() public form: FormGroup;

  /** formElementBlockConfig */
  public formElementBlockConfig: Ws10FormElementBlock;

  /** formControlName */
  public formControlName: string;

  /** optional field label  */
  public optional = this.ts.instant('FromCenterModule.formRendering.optionalField.std-headline');

  /** constructor
   * @param ts:TranslateService
   */
    public constructor (public ts: TranslateService) {}

  /** ngOnInit */
  public ngOnInit (): void {
    if (this.formField) {
      this.configureComponent(this.formField);
    }
  }
  /** configureComponent
   * @method configureComponent
   * @param {FormField} data
   */
   public configureComponent (data: FormField) {
    if (data && data.name && data.label && data.items && data.items.length !== 0) {
      const blockId = `block-id-${data.id}`;
      const blockAutId = `block-aut-id-${data.id}`;
      const fieldId = `field-id-${data.id}`;
      const labelId = `label-id-${data.id}`;

      /** construct select items */
      const selectItems = new Array<IFormSelectItem>();
      for (const item of data.items) {
        selectItems.push({label: item, value: item, state: data.value === item ? SELECTED : null});
      }
      this.formElementBlockConfig = {
        id: blockId,
        automation_id: blockAutId,
        labelConfig: {
          id: labelId,
          txtValue: data.required ? (data.label + '*') : (data.label + ' ' + this.optional),
          for: fieldId,
        },
        inputConfig: {
          select: {
            properties: {
              name: data.name,
              id: fieldId,
              items: selectItems,
              required: data.required,
              placeholder: data.placeholder,
              disabled: false,
            },
          },
        },
        helperText: data.hint,
        errorMessage: data.errorText,
      };
      this.formControlName = data.name;
      this.form.addControl(data.name, new FormControl(data.value));
    }
  }
}
